import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { EventEmitter } from '@angular/core';
import { NgbdModalContent } from '../../alert-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserData } from '../../model/UserData';
import { DatepickerComponent } from '../datepicker-component';

export interface Program {
  patient: string;
  attendance: string;
  activityminutes: string;
  weight: string;
  name: string;
}
@Component({
  selector: 'app-coachview',
  templateUrl: './coachview.component.html',
  styleUrls: ['./coachview.component.css']
})
export class CoachviewComponent implements OnInit {
  displayedColumns: string[] = ['patient',  'attendance', 'activityminutes', 'weight'];
  dataSource = new MatTableDataSource<Program>();
  data: LogsData[];
  programcode;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(DatepickerComponent) classDate: DatepickerComponent;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private bkoffService: BackOffServiceService,
    private cookie: CookieService,
    private router: Router,
    private modalService: NgbModal,
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    const PROGRAM_DATA: Program[] = [];
    this.cookie.set("viewPatientTrends", "false");

    this.bkoffService.getCoachPatients().then((res) => {
      this.data = res;
      console.log(res);
      this.data.forEach(element => {
        if (element.patient != null) {
          PROGRAM_DATA.push({ name : element.name, patient: element.patient, attendance: '', activityminutes: '', weight: '' });
        } else {
          PROGRAM_DATA.push({ name : element.name, patient: element.patient, attendance: '', activityminutes: '', weight: '' });
        }
      });
      this.dataSource = new MatTableDataSource<Program>(PROGRAM_DATA);
      this.dataSource.sort = this.sort;
    });
  }

  updatePatientDataAll() {
    this.dataSource.data.forEach(element => {
      if ((element.attendance !== undefined && element.attendance !== '')
        && (element.weight !== undefined && element.weight !== '')
        && (element.activityminutes !== undefined && element.activityminutes !== '')) {
        this.updatePatientData(element);
      }
    });


  }

  updatePatientData(row) {
    if (row.attendance === undefined || row.attendance === '') {
      this.sendUserFeedback('Attendance field is mandatory.', 'Warn: PatientId :' + row.patient);
      return;
    }
    this.bkoffService.saveCoachData(row, this.classDate.dateEntry.toString()).then(
      (sucess) => {
        this.sendUserFeedback('Patient data saved!', 'Info');
        row.attendance = '';
        row.activityminutes = '';
        row.weight = '';
      }, (error) => {
        this.sendUserFeedback('Error Occurred while saving patient data', 'Error');
      });
  }

  viewPatientData(row) {
    console.log(row.patient);
    console.log(this.cookie.get("patientID"));
    console.log(this.cookie.get('userObjectId'));
    this.cookie.set("patientID", row.patient);
    this.router.navigateByUrl('/activitytrends');
  }

  sendUserFeedback(message, title) {
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.name = message;
    modalRef.componentInstance.title = title;
  }

}
